/* eslint-disable max-lines-per-function --
   TODO: 招募前 sprint 拆組件 (TODO-frontend-eslint-ci-warnings-as-errors)。
   2026-02-06 規則加入時 87 個既有違規凍結為 baseline，新檔/新函數仍受 hook 攔截。
*/
// frontend/src/components/Auth/Register.jsx
// 使用者註冊表單元件

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  Alert,
  CircularProgress,
  InputAdornment,
  IconButton,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Divider,
} from '@mui/material';
import {
  Visibility,
  VisibilityOff,
  AccountCircle,
  Email,
  Lock,
  Badge,
  School,
  Person,
  Description,
} from '@mui/icons-material';
import authService from '../../services/authService';

const steps = ['帳號資訊', '個人資料', '申請原因'];

const Register = () => {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    studentId: '',
    className: '',
    realName: '',
    applicationReason: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  // 處理輸入變更
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // 清除該欄位的錯誤
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    setError('');
  };

  // 驗證第一步（帳號資訊）
  const validateStep1 = () => {
    const errors = {};

    // 使用者名稱驗證
    if (!formData.username) {
      errors.username = '請輸入使用者名稱';
    } else if (formData.username.length < 3 || formData.username.length > 20) {
      errors.username = '使用者名稱必須是 3-20 個字元';
    } else if (!/^[a-zA-Z0-9_]+$/.test(formData.username)) {
      errors.username = '使用者名稱只能包含英文字母、數字和底線';
    }

    // Email 驗證
    if (!formData.email) {
      errors.email = '請輸入電子郵件';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = '請輸入有效的電子郵件地址';
    }

    // 密碼驗證
    if (!formData.password) {
      errors.password = '請輸入密碼';
    } else if (formData.password.length < 8) {
      errors.password = '密碼至少需要 8 個字元';
    }

    // 確認密碼
    if (!formData.confirmPassword) {
      errors.confirmPassword = '請確認密碼';
    } else if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = '兩次輸入的密碼不一致';
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // 驗證第二步（個人資料）
  const validateStep2 = () => {
    const errors = {};

    if (!formData.studentId) {
      errors.studentId = '請輸入學號';
    }

    if (!formData.className) {
      errors.className = '請輸入班級/講堂';
    }

    if (!formData.realName) {
      errors.realName = '請輸入真實姓名';
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // 驗證第三步（申請原因）
  const validateStep3 = () => {
    const errors = {};

    if (!formData.applicationReason) {
      errors.applicationReason = '請輸入申請原因';
    } else if (formData.applicationReason.length < 10) {
      errors.applicationReason = '申請原因至少需要 10 個字元';
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // 下一步
  const handleNext = () => {
    let isValid = false;

    switch (activeStep) {
      case 0:
        isValid = validateStep1();
        break;
      case 1:
        isValid = validateStep2();
        break;
      case 2:
        isValid = validateStep3();
        break;
      default:
        isValid = true;
    }

    if (isValid) {
      setActiveStep((prev) => prev + 1);
    }
  };

  // 上一步
  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  // 處理表單提交
  const handleSubmit = async () => {
    if (!validateStep3()) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await authService.register({
        username: formData.username,
        email: formData.email,
        password: formData.password,
        studentId: formData.studentId,
        className: formData.className,
        realName: formData.realName,
        applicationReason: formData.applicationReason,
      });

      if (response.success) {
        setSuccess(true);
      }
    } catch (err) {
      console.error('註冊錯誤:', err);

      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err.response?.data?.errors) {
        // 處理欄位驗證錯誤
        const errors = {};
        err.response.data.errors.forEach((e) => {
          errors[e.field] = e.message;
        });
        setFieldErrors(errors);
      } else {
        setError('註冊失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  };

  // 成功畫面
  if (success) {
    return (
      <Box sx={{ textAlign: 'center', py: 3 }}>
        <Alert severity="success" sx={{ mb: 3 }}>
          註冊申請已送出！請等待管理員審核。
        </Alert>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          您的帳號申請已成功送出，管理員會盡快審核。
          <br />
          審核通過後，您將可以使用註冊的帳號登入系統。
        </Typography>
        <Button variant="contained" onClick={() => navigate('/login')}>
          返回登入頁面
        </Button>
      </Box>
    );
  }

  // 渲染步驟內容
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>
            {/* 使用者名稱 */}
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="使用者名稱"
              name="username"
              autoComplete="username"
              autoFocus
              value={formData.username}
              onChange={handleChange}
              disabled={loading}
              error={!!fieldErrors.username}
              helperText={fieldErrors.username || '3-20 個字元，只能包含英文、數字和底線'}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
            />

            {/* 電子郵件 */}
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="電子郵件"
              name="email"
              type="email"
              autoComplete="email"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
              error={!!fieldErrors.email}
              helperText={fieldErrors.email}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email />
                  </InputAdornment>
                ),
              }}
            />

            {/* 密碼 */}
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="密碼"
              type={showPassword ? 'text' : 'password'}
              id="password"
              autoComplete="new-password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
              error={!!fieldErrors.password}
              helperText={fieldErrors.password || '至少 8 個字元'}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      disabled={loading}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* 確認密碼 */}
            <TextField
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label="確認密碼"
              type={showConfirmPassword ? 'text' : 'password'}
              id="confirmPassword"
              autoComplete="new-password"
              value={formData.confirmPassword}
              onChange={handleChange}
              disabled={loading}
              error={!!fieldErrors.confirmPassword}
              helperText={fieldErrors.confirmPassword}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle confirm password visibility"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      edge="end"
                      disabled={loading}
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </>
        );

      case 1:
        return (
          <>
            {/* 學號 */}
            <TextField
              margin="normal"
              required
              fullWidth
              id="studentId"
              label="學號"
              name="studentId"
              autoFocus
              value={formData.studentId}
              onChange={handleChange}
              disabled={loading}
              error={!!fieldErrors.studentId}
              helperText={fieldErrors.studentId}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Badge />
                  </InputAdornment>
                ),
              }}
            />

            {/* 班級/講堂 */}
            <TextField
              margin="normal"
              required
              fullWidth
              id="className"
              label="班級/講堂"
              name="className"
              value={formData.className}
              onChange={handleChange}
              disabled={loading}
              error={!!fieldErrors.className}
              helperText={fieldErrors.className}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <School />
                  </InputAdornment>
                ),
              }}
            />

            {/* 真實姓名 */}
            <TextField
              margin="normal"
              required
              fullWidth
              id="realName"
              label="真實姓名"
              name="realName"
              value={formData.realName}
              onChange={handleChange}
              disabled={loading}
              error={!!fieldErrors.realName}
              helperText={fieldErrors.realName}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person />
                  </InputAdornment>
                ),
              }}
            />
          </>
        );

      case 2:
        return (
          <>
            {/* 申請原因 */}
            <TextField
              margin="normal"
              required
              fullWidth
              id="applicationReason"
              label="申請使用資料庫的原因"
              name="applicationReason"
              multiline
              rows={4}
              autoFocus
              value={formData.applicationReason}
              onChange={handleChange}
              disabled={loading}
              error={!!fieldErrors.applicationReason}
              helperText={
                fieldErrors.applicationReason || '請說明您申請使用此資料庫的原因（至少 10 個字元）'
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ alignSelf: 'flex-start', mt: 1.5 }}>
                    <Description />
                  </InputAdornment>
                ),
              }}
            />

            <Divider sx={{ my: 2 }} />

            {/* 確認資訊摘要 */}
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              請確認您的申請資訊：
            </Typography>
            <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 1 }}>
              <Typography variant="body2">
                <strong>使用者名稱：</strong> {formData.username}
              </Typography>
              <Typography variant="body2">
                <strong>電子郵件：</strong> {formData.email}
              </Typography>
              <Typography variant="body2">
                <strong>學號：</strong> {formData.studentId}
              </Typography>
              <Typography variant="body2">
                <strong>班級/講堂：</strong> {formData.className}
              </Typography>
              <Typography variant="body2">
                <strong>真實姓名：</strong> {formData.realName}
              </Typography>
            </Box>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Box>
      {/* 步驟指示器 */}
      <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* 錯誤訊息 */}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {/* 步驟內容 */}
      {renderStepContent(activeStep)}

      {/* 導覽按鈕 */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button disabled={activeStep === 0 || loading} onClick={handleBack}>
          上一步
        </Button>

        {activeStep === steps.length - 1 ? (
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? '送出中...' : '送出申請'}
          </Button>
        ) : (
          <Button variant="contained" onClick={handleNext} disabled={loading}>
            下一步
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default Register;
